
















import { Component, Vue, Prop, Watch} from 'vue-property-decorator';
import Ajax from '../../../lib/ajax'
import AbpBase from '../../../lib/abpbase'
import SpecialProjectAddInfo from './specialProjectAddInfo.vue'
@Component({
    name:'specialProjectAdd',
    components:{
        SpecialProjectAddInfo
    }
})
export default class SpecialProjectAdd extends AbpBase  {
    @Prop() editData:Object;
    initData:any = {
        formData: {},
        dicData: {
            userList: []
        }
    }
    //提交
    async Submit(type:any) {
        (this as any).$refs.specialProjectAddInfo.Submit('add');
    }
    //重置弹窗
    ResetForm() {
        (this as any).$refs.addForm.resetFields();
        this.initData.formData = {}
    }
    async GetDic() {
        await this.$store.dispatch('project/GetAllUser');
        this.initData.dicData.userList = this.$store.state.project.userList;
    }
    //验证规则
    rules:any = {
        projectName: [{ required: true, message: '请填写项目名称', trigger: 'blur' }],
        majorField: [{ required: true, message: '请填写主要研究领域', trigger: 'blur' }],
        purpose: [{ required: true, message: '请填写研究目的与意义', trigger: 'blur' }],
        majorContent: [{ required: true, message: '请填写主要研究内容', trigger: 'blur' }],
        evaluatIndex: [{ required: true, message: '请填写考核指标', trigger: 'blur' }],
        beginDt: [{ required: true, type: 'date', message: '请选择项目开始时间', trigger: 'blur' }],
        endDt: [{ required: true, type: 'date', message: '请选择项目结束时间', trigger: 'blur' }],
        projectLeaderId: [{ required: true, type: 'number', message: '请选择项目负责人', trigger: 'change' }],
        applyAmount: [{ required: true, message: '请填写申请经费', trigger: 'blur' }],
        seflAmount: [{ required: true, message: '请填写自筹资金', trigger: 'blur' }],
    }
    mounted() {
        this.GetDic();
    }

    //编辑弹窗
    //更新数据
    @Watch('editData')
    editDataChange(newVal:any, oldVal:any){
        let tempVal = newVal;
        tempVal.projectLeaderId = tempVal.projectLeader ? tempVal.projectLeader.id : undefined;
        tempVal.applyAmount = tempVal.seflAmount ? tempVal.applyAmount.toString() : undefined;
        tempVal.seflAmount = tempVal.seflAmount ? tempVal.seflAmount.toString() : undefined;
        tempVal.beginDt = new Date(tempVal.beginDt);
        tempVal.endDt = new Date(tempVal.endDt);
        this.initData.formData = tempVal;
    }
}
